function ChineseExperienceLayer() {
  return (
    <div className="chinese-experience-layer" aria-hidden="true">
      <div className="bg-lantern" />
      <img src="/images-optimized/guangji.webp" className="floating-art" alt="" loading="lazy" decoding="async" />
      <img src="/assets/lantern.webp" className="lantern l1" alt="" loading="lazy" decoding="async" />
      <img src="/assets/lantern.webp" className="lantern l2" alt="" loading="lazy" decoding="async" />
      <img src="/assets/lantern.webp" className="lantern l3" alt="" loading="lazy" decoding="async" />
      <img src="/assets/lantern.webp" className="corner-lantern" alt="" loading="lazy" decoding="async" />
      <img src="/assets/knot.webp" className="corner-knot" alt="" loading="lazy" decoding="async" />
    </div>
  );
}

export default ChineseExperienceLayer;
